// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DesignShareButton_wrapper__G2n_W","shareIconButton":"DesignShareButton_shareIconButton__LflY_","popover":"DesignShareButton_popover__r4iv6"};